import React, { useState, useEffect } from 'react';
import Spinner from '../../../Spinner';
import checkIcon from '../../../../assets/icons/check-icon.png';
import { useAlertsContext } from '../../../../contexts/AlertsContext';
import axios from 'axios';
import { useUserContext } from '../../../../contexts/UserContext';
import './FiresModal.scss';

export default function FireAlertsModal(props) {
    const {
        getToken
    } = useUserContext();
    
    const {
        alerts,
        setAlerts
    } = useAlertsContext();

    const {
        setModal,
        modal
    } = props;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [alert, setAlert] = useState(null);

    const fireId = modal.content?.fireId;

    useEffect(() => {
        if (alerts.filter((a) => a.incident_id === fireId).length > 0) {
            setAlert(alerts.filter((a) => a.incident_id === fireId)[0]);
        }
    }, [alerts]);

    const turnOnNotifications = (fireId) => {
        setLoading(true);
        getToken()
        .then((token) => {
            axios.post('https://firewatch-api.space-eyes.com/user/notifications', 
            {
                team_id: null,
                area_id: null,
                incident_id: fireId
            },
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
                setAlerts([
                    ...alerts.filter((a) => a && a.id !== response.data.id),
                    response.data
                ])
                setLoading(false);
            }).catch((error) => {
                console.log('error turning on notifications', error);
                setLoading(false);
                setError('Trouble turning on notifications. Please try again.');
            })
        })
        .catch((error) => {
            console.error('Failed to get token:', error);
            setError('Trouble turning on notifications. Please try again')
        });
    }
 
     const turnOffNotifications = (alertID) => {
          setLoading(true);
          getToken()
          .then((token) => {
              axios.delete(`https://firewatch-api.space-eyes.com/user/notifications?id=${alertID}`, {
                 headers: {
                     'Authorization': `Bearer ${token}`
                 }
              }).then((response) => {
                setAlerts(alerts.filter((a) => a.id !== alertID));
                setAlert(null);
                setLoading(false);
              }).catch((error) => {
                 console.log('error turning off notifications', error);
                 setLoading(false);
                 setError('Trouble turning off notifications. Please try again.')
              })
          })
          .catch((error) => {
             console.error('Failed to get token:', error);
             setError('Trouble turning off notifications. Please try again.')
          });
      }

    return (
        <div className='fires-modal'>
            <div className='fires-modal-title'>Fire Specific Alerts</div>
            <div className='fires-modal-content'>
                <div className='fires-modal-content-text'>Receive real-time email alerts everytime there is an update to this specific fire.</div>
            </div>
            {error && <div className='fires-modal-content-error'>{error}</div>}
            {loading ?
            <div style={{ paddingTop: '1rem' }}>
                <Spinner />
            </div>
            :
            <div className='fires-modal-content-alert-btns'>
                {!alert ?
                <div 
                    className='fires-modal-content-alert-btns-btn-save'
                    onClick={() => turnOnNotifications(fireId)}
                    >
                 Turn On
                </div>
                :
                <div 
                    className='fires-modal-content-alert-btns-btn-off'
                    onClick={() => turnOffNotifications(alert.id)}
                    >
                 Turn Off
                </div>
                }
                <div 
                    className='fires-modal-content-alert-btns-btn-cancel'
                    onClick={() => {
                        setModal({
                            type: false,
                            content: null
                        })
                    }}
                    >
                    Cancel
                </div>
            </div>
            }
        </div>
    )
}
